var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0901 13.09C18.9301 13.09 18.7701 13.04 18.6301 12.93C14.6001 9.82002 9.39005 9.82002 5.36005 12.93C5.03005 13.18 4.56005 13.12 4.31005 12.8C4.06005 12.47 4.12005 12 4.44005 11.75C9.03005 8.20002 14.9601 8.20002 19.5401 11.75C19.8701 12 19.9301 12.47 19.6701 12.8C19.5401 12.99 19.3201 13.09 19.0901 13.09Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.61002C21.84 9.61002 21.68 9.56002 21.54 9.45002C15.74 4.97002 8.25001 4.97002 2.46001 9.45002C2.13001 9.70002 1.66001 9.64002 1.41001 9.32002C1.15001 9.00002 1.21001 8.52002 1.54001 8.27002C7.89001 3.36002 16.1 3.36002 22.46 8.27002C22.79 8.52002 22.85 8.99002 22.59 9.32002C22.45 9.51002 22.22 9.61002 22 9.61002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2099 16.74C17.0499 16.74 16.8899 16.69 16.7499 16.58C13.8699 14.35 10.1399 14.35 7.24995 16.58C6.91995 16.83 6.44995 16.77 6.19995 16.45C5.94995 16.12 6.00995 15.65 6.32995 15.4C9.76995 12.74 14.2199 12.74 17.6599 15.4C17.9899 15.65 18.0499 16.12 17.7899 16.45C17.6499 16.64 17.4299 16.74 17.2099 16.74Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 20.4C14.44 20.4 14.28 20.35 14.14 20.24C12.84 19.23 11.15 19.23 9.85004 20.24C9.52004 20.49 9.05004 20.43 8.80004 20.11C8.55004 19.78 8.61004 19.31 8.93004 19.06C10.79 17.62 13.19 17.62 15.05 19.06C15.38 19.31 15.44 19.78 15.18 20.11C15.05 20.29 14.83 20.4 14.6 20.4Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1632_4242",
    x1: 11.9937,
    y1: 9.08752,
    x2: 11.9937,
    y2: 13.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1632_4242",
    x1: 12,
    y1: 4.58752,
    x2: 12,
    y2: 9.61002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1632_4242",
    x1: 11.9986,
    y1: 13.405,
    x2: 11.9986,
    y2: 16.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1632_4242",
    x1: 11.9937,
    y1: 17.98,
    x2: 11.9937,
    y2: 20.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiColorIcon);
export default __webpack_public_path__ + "static/media/wifi-color-icon.211073d3df6071b3a6215a8488b5f3ae.svg";
export { ForwardRef as ReactComponent };